import useMutationApi from 'src/api/useMutationApi';

export interface UpdateUserPasswordRequest {
  password: string;
}

export interface UpdateUserPasswordResponse {
  success: boolean;
}

const useUpdateUserPassword = (userId: string) => {
  return useMutationApi<UpdateUserPasswordRequest, UpdateUserPasswordResponse>({
    endpoint: `organization/members/${userId}/password`,
    method: 'PUT',
  });
};

export default useUpdateUserPassword;
